import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import {
    IconDatabase, IconArchive, IconWorld, IconGenderFemale,
} from '@tabler/icons-react';

import theme from '../../data/theme';
import PageTitle from '../shared/PageTitle';
import ExportPanel from './ExportPanel';
import OpenDataStats from './OpenDataStats';
import getOpenDataLabels from './openDataLabels';
import {
    eksportoTeGjithaBizneset,
    eksportoBiznesetShuar,
    eksportoBiznesetHuaj,
    eksportoBiznesetFemra,
    eksportoTeGjithaBiznesetJson,
    eksportoBiznesetShuarJson,
    eksportoBiznesetHuajJson,
    eksportoBiznesetFemraJson,
} from '../../services/fetch-service';

const OPTIONS = [
    {
        key: 'teGjitha', icon: IconDatabase, excelFn: eksportoTeGjithaBizneset, jsonFn: eksportoTeGjithaBiznesetJson, prefix: 'Bizneset',
    },
    {
        key: 'shuar', icon: IconArchive, excelFn: eksportoBiznesetShuar, jsonFn: eksportoBiznesetShuarJson, prefix: 'Bizneset_Shuar',
    },
    {
        key: 'huaj', icon: IconWorld, excelFn: eksportoBiznesetHuaj, jsonFn: eksportoBiznesetHuajJson, prefix: 'Bizneset_Huaj',
    },
    {
        key: 'femra', icon: IconGenderFemale, excelFn: eksportoBiznesetFemra, jsonFn: eksportoBiznesetFemraJson, prefix: 'Bizneset_Grua_Vajzë',
    },
];

const ITEM_BASE = 'tw-w-full tw-flex tw-items-start tw-gap-3 tw-px-4 tw-py-3 tw-rounded-brand tw-border tw-border-solid tw-text-sm tw-text-left tw-cursor-pointer tw-transition-colors tw-font-inter';
const ITEM_ACTIVE = 'tw-border-navy-a40 tw-bg-navy-a10 tw-text-navy tw-font-semibold';
const ITEM_IDLE = 'tw-border-line tw-bg-paper hover:tw-bg-fieldhover tw-text-ink tw-font-medium';

function OpenDataPage(props) {
    const { locale } = props;
    const L = getOpenDataLabels(locale);

    const [selected, setSelected] = useState(OPTIONS[0].key);
    const active = OPTIONS.find((o) => o.key === selected) || OPTIONS[0];
    const activeLabels = L.options[active.key];

    return (
        <div className="OpenData-section tw-font-inter">
            <Helmet>
                <title>{`${L.pageTitle} — ${theme.fullName}`}</title>
            </Helmet>

            <PageTitle header={L.pageTitle} />

            <section className="full-margin">
                <p className="tw-text-muted tw-text-sm tw-mb-5 tw-max-w-3xl tw-leading-relaxed">{L.pageLead}</p>

                <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-5 lg:tw-gap-7 tw-mb-12">
                    <div className="tw-order-2 lg:tw-order-2 tw-flex-1 tw-min-w-0 tw-mt-6">
                        <ExportPanel
                            key={active.key}
                            excelFn={active.excelFn}
                            jsonFn={active.jsonFn}
                            fileNamePrefix={active.prefix}
                            locale={locale}
                            title={activeLabels.title}
                            desc={activeLabels.desc}
                            L={L}
                        />
                    </div>

                    <aside className="tw-order-1 lg:tw-order-1 lg:tw-w-72 tw-flex-shrink-0">
                        <h2 className="tw-m-0 tw-mb-3 tw-text-xs tw-uppercase tw-font-semibold tw-tracking-overline tw-text-muted">
                            {L.menuHeading}
                        </h2>
                        <nav className="tw-flex tw-flex-col tw-gap-2.5">
                            {OPTIONS.map((opt) => {
                                const Icon = opt.icon;
                                const isActive = opt.key === selected;
                                return (
                                    <button
                                        key={opt.key}
                                        type="button"
                                        aria-pressed={isActive}
                                        onClick={() => setSelected(opt.key)}
                                        className={`${ITEM_BASE} ${isActive ? ITEM_ACTIVE : ITEM_IDLE}`}
                                    >
                                        <Icon size={20} stroke={1.8} className="tw-flex-shrink-0 tw-mt-0.5" aria-hidden />
                                        <span>{L.options[opt.key].label}</span>
                                    </button>
                                );
                            })}
                        </nav>
                    </aside>
                </div>
            </section>

            <OpenDataStats locale={locale} L={L} />
        </div>
    );
}

OpenDataPage.propTypes = {
    locale: PropTypes.string,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(OpenDataPage);
